import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationElastic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAnimationElastic"><Path d="M3.5 20.5C3.5 20.5 3.5 3.5 6.68747 3.5C8.8125 3.5 8.81243 10.9375 11.4687 10.9375C14.125 10.9375 15.1875 6.43958 20.5 8.03333" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAnimationElastic;
